import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Api from "../../Api";
import { ListTags, NewTagModalForm } from "../../component";

const Tags = () => {
  interface Tag {
     appTagId: number,
     appTagName: string
  }

  const [tags, setTags] = useState<Tag[]>([]);

  const api = Api();
  const navigate = useNavigate();


  const TagValidationSchema = Yup.object().shape({
    appTagName: Yup.string().required("Tag is required"),
  });

  const handleCreateTag = (tagDetails: any) => {
    api.appTag.createAppTag(tagDetails).then((response: any) => {
      toast.success(response.message);
      getTags();
    });
  };

  const getTags = () => {
    api.appTag.getAppTags().then((response: any)=>{
      if(response){
        setTags([...response.appTags])
      }
    })
  };



  useEffect(() => {
    getTags();
  }, []);

  return (
    <div className="w-100 p-2">
      <div className="float-end">
        <NewTagModalForm
          TagValidationSchema={TagValidationSchema}
          onCreateNewTag={handleCreateTag}
        />
      </div>

      <ListTags tagsList={tags} />
    </div>
  );
};

export default Tags;
